import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import api from "#utils/api";
import PointCard from "#cards/PointCard";
import Modal from "./Modal";
import ViewMoreButton from "#components/helpers/ViewMoreButton";

const ProfilePointsModal = () => {
  const pointAwardsQuery = useSuspenseInfiniteQuery({
    queryKey: ["profile", "pointAwards"],
    queryFn: ({ pageParam }) => api.get(`/users/current/point_awards?page=${pageParam}`),
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => (pages.length < lastPage.total_pages ? pages.length + 1 : undefined),
  });

  const pointAwards = pointAwardsQuery.data.pages.map((p) => p.point_awards).flat();
  const pendingPoints = pointAwardsQuery.data.pages[0].pending_points;
  return (
    <Modal isOpen title={<h4>Points</h4>}>
      <div className="flex flex-col gap-3 max-w-[500px] mt-4">
        {pendingPoints.map((award, i) => (
          <PointCard key={i} pointAward={award} isPending />
        ))}
        {pointAwards.map((award) => (
          <PointCard key={award.id} pointAward={award} />
        ))}
        <ViewMoreButton {...pointAwardsQuery} />
      </div>
    </Modal>
  );
};

export default ProfilePointsModal;
